import banner from './banner'
import consent from './consent'
import bannerTextOverride from './bannerTextOverride'

export default { banner, consent, bannerTextOverride }
